module.exports = __webpack_public_path__ + "img/1.1cf50712.png";